import {load} from '@shopify/theme-sections';

import '../sections/article';
import initShareToggle from '../components/social-share';

document.addEventListener('DOMContentLoaded', () => {
  load('*');

  initShareToggle();
});
